import React from "react";
import HorizontalRule from "../../../../components/components/atoms/HorizontalRule";
import "./CheckoutHorizontalRule.less";

const CheckoutHorizontalRule = () => <HorizontalRule className="checkout-horizontal-rule" />;

export default CheckoutHorizontalRule;
